import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../lib/firebase/config";

/**
 * Marca conquistas como já ANUNCIADAS a este usuário (BUG-281) —
 * `users.badgesAnnounced`, client-safe (rules: lista ≤ 100). `arrayUnion` é
 * idempotente e converge entre dois aparelhos; mesmo trilho de
 * `markSeasonIntroShown`. Módulo próprio (e não dentro de
 * `gamificationService`) para o watcher ser testável sem Firestore.
 */
export async function markBadgesAnnounced(uid: string, badgeIds: readonly string[]): Promise<void> {
  if (badgeIds.length === 0) return;
  await updateDoc(doc(db, "users", uid), { badgesAnnounced: arrayUnion(...badgeIds) });
}
